export const _STEPS = {
  FILL_LYRIC: 0,
  SYNC_LYRIC: 1,
  FINISHED: 2,
  UPLOADING: 3,
}
